import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { ref, onValue } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import "../css/HistoryPage.css";

const HistoryPage = () => {
  const [summaries, setSummaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userUid, setUserUid] = useState(null);

  // 获取当前用户 UID（防止刷新后 auth 为空）
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserUid(user.uid);
      } else {
        setUserUid(null);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // 根据 UID 去加载数据（延迟挂载）
  useEffect(() => {
    if (!userUid) return;

    const userSummaryRef = ref(db, `summaries/${userUid}`);
    const unsubscribe = onValue(userSummaryRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const result = Object.entries(data).map(([id, item]) => ({
          id,
          ...item,
        }));
        setSummaries(result);
      } else {
        setSummaries([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userUid]);

  return (
    <div className="history-page">
      <h2>📚 My Question History</h2>
      {loading ? (
        <p>Loading...</p>
      ) : summaries.length === 0 ? (
        <p>No questions saved yet.</p>
      ) : (
        summaries.map((item, idx) => (
          <div key={idx} className="summary-card">
            <h3>{item.title}</h3>
            <p>
              <strong>Question:</strong> {item.question}
            </p>
            <p>
              <strong>AI Summary:</strong> {item.summary}
            </p>
            <p className="timestamp">
              {new Date(item.timestamp).toLocaleString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
};

export default HistoryPage;
